<template>
  <vs-card v-if="!loading">
    <template slot="header">
      <div>
        Tipo de Usuario:
        <span style="float: right; color: green;">{{ tipousuario }}</span>
      </div>
      <div>
        Tipo de Persona:
        <span style="float: right; color: green;">{{ tipopersona }}</span>
      </div>
    </template>
    <div v-if="pp != null">
      <div v-if="transacciones>0">
        # Transacciones:
        <span style="float: right;color:red">{{ transacciones }}</span>
      </div>
      <div>
        UID:
        <span style="float: right;">{{ userid }}</span>
      </div>
      <div>
        Correo:
        <span style="float: right;">{{ email }}</span>
      </div>
      <div>
        Acceso:
        <span style="float: right;">{{ getActive(acceso) }}</span>
      </div>
      <div>2FA Activado:
        <span style="float: right;">{{ mfa }}</span>
      </div>
      <div>
        Último Inicio de Sesión:
        <span style="float: right;">{{ login | human_date }}</span>
      </div>
      <div>
        PPID:
        <span style="float: right;">{{ pp.id }}</span>
      </div>
      <div>
        Nombre:
        <span style="float: right;">{{ getName(pp) }}</span>
      </div>
      <div>
        Fecha de Nacimiento:
        <span style="float: right;">{{ pp.birth_date | human_date }}</span>
      </div>
      <div>
        Estado de Nacimiento:
        <span style="float: right;">{{ pp.state }}</span>
      </div>
      <div>
        País de Nacimiento:
        <span style="float: right;">{{ pp.origin_country_str }}</span>
      </div>
      <div>
        Nacionalidad:
        <span style="float: right;">{{ pp.citizenship_str }}</span>
      </div>
      <div>
        Genero:
        <span style="float: right;" v-if="pp.gender === 1">Masculino</span>
        <span style="float: right;" v-if="pp.gender === 2">Femenino</span>
        <span style="float: right;" v-if="pp.gender === 0">Masculino</span>
      </div>
      <div>
        RFC:
        <span style="float: right;">{{ pp.rfc }}</span>
      </div>
      <div>
        CURP:
        <span style="float: right;">{{ pp.curp }}</span>
      </div>
      <div>
        Teléfono:
        <span style="float: right;">{{ pp.format_phone }}</span>
      </div>
      <div>
        País de residencia:
        <span style="float: right;">{{ pp.address_country_str }}</span>
      </div>
      <div>
        Ocupación:
        <span style="float: right;">{{ pp.personal_occupation }}</span>
      </div>
      <div>
        Perfil Fiscal:
        <span style="float: right;" v-if="pp.gender === 1">PF con actividad empresarial</span>
        <span style="float: right;" v-if="pp.gender === 0">Persona Física</span>
      </div>
      <div>
        U. Actualización Expediente:
        <span style="float: right;">{{ pp.last_update_confirmation_date | human_date }}</span>
      </div>
      <div>
        U. Actualización:
        <span style="float: right;">{{ pp.updated_at | human_date }}</span>
      </div>
      <div>
        Creado:
        <span style="float: right;">{{ pp.created_at | human_date }}</span>
      </div>
      <br>
      <div>
        Código de INE:
        <span style="float: right;">{{ pp.official_id_code }}</span>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="pp.official_id_front_file !== null">
          <formdata-file-upload
              :popup="true"
              field="official_id_front_file"
              title="ID Oficial Frontal"
              :path="`/storage/private/user/${userid}`"
              :src="pp.official_id_front_file"
              :user-id="userid"/>
        </div>
        <div class="col-md-6" v-if="pp.official_id_back_file !== null">
          <formdata-file-upload
              :popup="true"
              field="official_id_back_file"
              title="ID Oficial Posterior"
              :path="`/storage/private/user/${userid}`"
              :src="pp.official_id_back_file"
              :user-id="userid"/>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script lang="js">

import * as moment from "moment";

export default {
  name: 'expediente',
  props: ['loading',
    'tipousuario',
    'tipopersona',
    'pp',
    'transacciones',
    'userid',
    'email',
    'acceso',
    'login',
    'mfa'],
  filters: {
    human_date(date) {
      return date == null ? '' : moment(date).lang("es").format("D MMM YY");
    }
  },
  mounted() {
    if (this.loading) {
      this.$vs.loading();
    } else {
      this.$vs.loading.close();
    }
  },
  data() {
    return {}
  },
  methods: {
    getName(pp) {
      let nombre = '';
      if (pp.first_name != null) nombre = nombre + ' ' + pp.first_name;
      if (pp.second_name != null) nombre = nombre + ' ' + pp.second_name;
      if (pp.last_name_1 != null) nombre = nombre + ' ' + pp.last_name_1;
      if (pp.last_name_2 != null) nombre = nombre + ' ' + pp.last_name_2;
      return nombre;
    },
    getActive(active) {
      if (active === 0) {
        return 'Cuenta Inactiva';
      } else {
        return 'Cuenta Activada';
      }
    },
  },
  computed: {}
}


</script>

<style scoped lang="scss">
.src-views-admin-expediente-vue {

}
</style>
